import { ChangeEvent, memo, useMemo, useRef } from "react";
import classNames from "classnames";
import { v1 } from "uuid";

import styles from "./style.module.scss";

export type CheckBoxIconProps = {
  id?: string,
  value?: boolean,
  checked?: boolean,
  disabled?: boolean,
  visible?: boolean,
  onChange?: (e: ChangeEvent<HTMLInputElement>, value: boolean) => void,
  label?: string,
  className?: string,
  style?: object,
}

const CheckBoxIcon = memo<CheckBoxIconProps>((
  {
    id,
    value,
    checked,
    disabled,
    onChange,
    label,
    className,
    style,
    visible,
    ...restProps
  }) => {
  const resolvedRef = useRef<HTMLInputElement>(null);
  const realId = useMemo(() => id || v1(), [ id ]);
  const onValueChanged = useMemo(() => (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      return onChange?.(e, e.target.checked);
    }
  }, [ disabled, onChange ]);

  return (
    <label
      htmlFor={realId}
      className={classNames(styles.root, className)}
      style={style}
    >
      <input
        {...restProps}
        id={realId}
        ref={resolvedRef}
        value={label}
        checked={value === undefined ? checked : value}
        disabled={disabled}
        onChange={onValueChanged}
        type="checkbox"
      />
      <div role="button" className={styles.icon} />
    </label>
  );
});

export default CheckBoxIcon;
